import { MessageSquare, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateFollowingUpWithACustomerUsingVoiceCallsAr: TemplateAr = {
  name: 'أتمتة متابعة العميل عبر المكالمات الصوتية بالذكاء الاصطناعي',
  shortName: 'أتمتة متابعات المكالمات الصوتية بالذكاء الاصطناعي',
  description:
    'أطلق مكالمات متابعة صوتية مخصصة بناءً على محتوى التذكرة أو تواصل العميل. الذكاء الاصطناعي يتولى التواصل تلقائياً.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'تذكرة' },
    { icon: Sparkles, label: 'الـ AI يُطلق' },
    { icon: Phone, label: 'مكالمة صوتية', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ التذكرة اللي تحتاج اهتماماً شخصياً تطلع مكالمة صوتية تلقائياً. الـ AI يحلل محتوى التذكرة ومشاعر العميل ودرجة الاستعجال، ويعرف وين المكالمة تحل المشكلة أسرع من التواصل الكتابي. ويجدول المكالمة في الوقت الأنسب، ويجهّز الموظف بالسياق الكامل.',
    paragraph2:
      'جدولة المكالمات ونتائجها توصل للأدوات اللي تفضّلها: دعوات تقويم، أو إشعارات Slack، أو مهام في CRM. والوكيل يتصل بنظام الهاتف عندك، ويسجّل ملخص كل مكالمة في التذكرة تلقائياً.',
  },
  benefits: [
    'المشكلة المعقّدة تنحل أسرع بالصوت',
    'المكالمة تجي في توقيت عميلك، مو في توقيتك',
    'موظفك يدخل المكالمة والسياق كامل معه',
    'كل مكالمة تنسجل ويطلع لها ملخص تلقائي',
    'درجات رضا العملاء تتحسّن',
    'بلا جدولة يدوية.',
  ],
};
